import React from "react";
import "./footer.css";
import { useState, useEffect } from "react";
import { SocialIcon } from "react-social-icons";
import socialIconsData from "../reuseable_comp/socialIconsData";
import { FaArrowUp } from "react-icons/fa";
import { Link } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://api.mitadtu.in";

const Footer = () => {
  const [showButton, setShowButton] = useState(false);
  const [visitorCount, setVisitorCount] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const trackVisitor = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/visitors/track`, {
          method: "POST",
        });
        const data = await res.json();
        if (data.success) {
          setVisitorCount(data.count);
        }
      } catch (err) {
        console.error("Error tracking visitor:", err);
      }
    };
    trackVisitor();
  }, []);

  // Scroll to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">
      {/* TOP SECTIONS */}
      <div className="footer-top">
        {/* Section 1: Logos + Address + Map */}
        <div className="footer-section">
          <div className="footer-first-section">
            <div className="footer-logos">
              <img
                src="/assets/images/icons/manet_logo.webp"
                alt="Logo 1"
                style={{ borderRadius: "50%" }}
              />
              <img src="/assets/images/icons/mit_logo.webp" alt="Logo 2" />
            </div>
            <p>
              Gate No.140, Rajbaug, Pune-Solapur Highway, Loni-kalbhor, Pune,
              Maharashtra 412201.
            </p>

            <div className="footer-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.8391448310713!2d74.02160147595619!3d18.49094397007696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2e96c3b18c937%3A0xe1856bf8cd99e4c5!2sManet%20main%20building!5e0!3m2!1sen!2sin!4v1763699722324!5m2!1sen!2sin"
                allowFullScreen
                loading="lazy"
                title="MANET Location Map"
              ></iframe>

            </div>
          </div>
        </div>

        {/* Section 2: Quick Links */}
        <div className="footer-rows">
          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/admissions/admission-procedure">
                  Admission Procedure
                </Link>
              </li>
              <li>
                <Link to="/academics/academic-calendar">
                  Academic Calendar{" "}
                </Link>
              </li>
              <li>
                <Link to="/admissions/fee-structure">Fee Structure </Link>
              </li>
              <li>
                <Link to="/lifeatcampus/campus-life">Life @ MANET </Link>
              </li>
              <li>
                <Link to="/placement/placement-statistics">
                  Placement Statistics
                </Link>
              </li>
              <li>
                <Link to="/lifeatcampus/gallery">Gallery </Link>
              </li>
              <li>
                <Link to="/lifeatcampus/manet-blogs">MANET Blogs </Link>
              </li>
              <li>
                <Link to="/contact">Contact </Link>
              </li>
              <li>
                <Link to="https://docs.google.com/forms/d/e/1FAIpQLSeMFd7XDa2g0p6LV1eTqPFffoC2Xhsb-ucLID4RRpZbM7eFvQ/viewform?pli=1">Alumni Registration Form</Link>
              </li>
            </ul>
          </div>

          {/* Section 3: Quick Links + Social Connect */}
          <div className="footer-section">
            <h4 className="footer-title">MIT Group of Institutes</h4>
            <ul className="footer-links">
              <li>
                <Link to="https://mituniversity.ac.in/">
                  MIT ADT University{" "}
                </Link>
              </li>
              <li>
                <Link to="https://mitpune.ac.in/">
                  MIT Group Of Institutions
                </Link>
              </li>
              <li>
                <Link to="https://mitwpu.edu.in/">MIT WPU, Pune </Link>
              </li>
              <li>
                <Link to="https://www.avantikauniversity.edu.in/">
                  Avantika University, Ujjain,
                </Link>
              </li>
              <li>
                <Link to="https://www.mitgurukul.com/">
                  Vishwashanti Gurukul Schools
                </Link>
              </li>
            </ul>
          </div>

          {/* Section 4: Quick Links + Visitor Count */}
          <div className="footer-section">
            <h4 className="footer-title">Our Initiatives</h4>
            <ul className="footer-links">
              <li>
                <Link to="https://wpcyouthmission.com/">
                  World Peace Centre{" "}
                </Link>
              </li>
              <li>
                <Link to="https://www.bharatiyachhatrasansad.org/">
                  Bharatiya Chhatra Sansad{" "}
                </Link>
              </li>
              <li>
                <Link to="https://mitwpu.edu.in/about-us/social-initiatives/bharat-asmita-national-awards">
                  Bharat Asmita Awards
                </Link>
              </li>
              <li>
                <Link to="https://www.mituniversity.ac.in/about-us/raj-kapoor-memorial-avenue">
                  Raj Kapoor Memorial
                </Link>
              </li>
            </ul>
          </div>

          {/* Section 5:  Visitor Count +  Social Connect  */}
          <div className="footer-section">
            <h4 className="footer-title">Site Visitors</h4>
            <p className="visitor-count">
              {visitorCount.toString().split("").join(" ")}
            </p>

            <h4 className="footer-title">Connect With Us</h4>
            <div className="footer-social-icons">
              {socialIconsData.map(({ url, network, bgColor }, index) => (
                <SocialIcon
                  key={index}
                  className="foot-social-icons"
                  url={url}
                  network={network}
                  bgColor={bgColor}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* back to top button */}
      {showButton && (
        <button className="back-to-top" onClick={scrollToTop}>
          <FaArrowUp />
        </button>
      )}

      {/* FOOTER BOTTOM */}
      <div className="footer-bottom">
        <p>
          MANET, Pune © 2025. All Rights Reserved. Designed & Developed by
          MIT-ADT Website Department.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
